import React from 'react'
import _get from 'lodash/get'
import _isEqual from 'lodash/isEqual'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { RN_ROLES } from '../constants/roles'
import { PreLoader } from '../_library/PreLoader'

import { FETCH_SESSION } from '../../_common/redux/auth/actions'
import { deleteCookieByName, getCookieByName } from '../utils/cookies'

const cookieName = 'X-TF-ECOMMERCE'

const defaultOptions = {
  redirectUrl: '/',
  some_role: [],
  every_role: [],
  condition: props => true,
}

const privateRouterHOC = (Component, options) => {
  const updatedOptions = {
    ...defaultOptions,
    ...options,
  }

  @connect(
    state => ({
      user: state.auth.user,
      checked: state.auth.checked,
      pendingTwoFactor: state.auth.pendingTwoFactor,
      isRnDomain: state.shared.isRnDomain,
      isMcDomain: state.shared.isMcDomain,
    }),
    {
      FETCH_SESSION,
    },
  )
  class C extends React.PureComponent {
    state = {
      content: null,
      interval: null,
      exist: false,
    }

    componentDidMount() {
      this.check(this.props)
      this.checkSession()
      this.handleCookieChange()
    }

    componentDidUpdate(prevProps, prevState) {
      const { exist } = this.state

      if (!_isEqual(prevProps, this.props)) {
        this.check(this.props)
      }

      if (prevState.exist !== exist) {
        this.checkSession(this.props)
      }
    }

    componentWillUnmount() {
      const { interval } = this.state
      interval && clearInterval(interval)
    }

    checkSession = async () => {
      const { FETCH_SESSION } = this.props

      await FETCH_SESSION({ hideError: true })
    }

    check = async _props => {
      const { user, checked, pendingTwoFactor, isRnDomain, isMcDomain, ...props } = _props
      const {
        history: { replace },
        location: { pathname = '/' },
      } = props
      const { redirectUrl, some_role, every_role, condition } = updatedOptions
      let content = null
      if (!user && !checked) {
        content = <PreLoader isRnDomain={isRnDomain} isMcDomain={isMcDomain} />
      } else if (!user && checked && pendingTwoFactor && getCookieByName(cookieName)) {
        const search = queryString.stringify({ next: pathname })
        replace({ pathname: '/two-factor', search })
        return
      } else if (!user && checked) {
        deleteCookieByName('X-TF-ECOMMERCE')
        const search = queryString.stringify({ next: pathname })
        replace({ pathname: '/signin', search })
        return
      } else if (user) {
        const rnRoles = _get(user, 'rnRoles', [])
        let access = true
        if (some_role.length && !RN_ROLES.hasSomeRoles(rnRoles, some_role)) {
          access = false
        }

        if (every_role.length && !RN_ROLES.hasRoles(rnRoles, every_role)) {
          access = false
        }

        if (!condition(this.props)) {
          access = false
        }

        if (access) {
          if (Component) {
            content = <Component {...props} />
          } else {
            content = props.children || null
          }
        } else {
          if (typeof redirectUrl === 'string') {
            replace(redirectUrl)
          } else if (typeof redirectUrl === 'function') {
            replace(redirectUrl(this.props) || '/')
          }
          return
        }
      }
      this.setState(() => ({ content }))
    }

    handleCookieChange = () => {
      const interval = setInterval(() => this.setState({ exist: !!getCookieByName(cookieName) }), 500)
      this.setState({ interval })
    }

    render() {
      const { content } = this.state
      return content
    }
  }

  return C
}

export { privateRouterHOC }
